import { render, staticRenderFns } from "./MdTextSpeech.vue?vue&type=template&id=34fff2b0&"
import script from "./MdTextSpeech.vue?vue&type=script&lang=js&"
export * from "./MdTextSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports